import { FNOLRoadsideAssistance } from '../../../../../../pages/FNOL'

export default [
  {
    is: { roadsideAssistance: 'roadsideAssistanceStart' },
    page: FNOLRoadsideAssistance,
  },
]
